import { render, staticRenderFns } from "./QuarantinedMails.vue?vue&type=template&id=0574a514&"
import script from "./QuarantinedMails.vue?vue&type=script&lang=js&"
export * from "./QuarantinedMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports